import BreadCrumb from "Components/Common/BreadCrumb";
import "react-toastify/dist/ReactToastify.css";
import { Card, Container, } from "reactstrap";
import "./RealtimeRiderPerformance.scss";
import { ToastContainer } from "react-toastify";
import profile from '../../../assets/images/about.jpg'
import waring from '../../../assets/images/warning-2.svg'
import cellTab from '../../../assets/images/CellTab.svg'
import noti from '../../../assets/images/notification-circle.svg'
import tick from '../../../assets/images/tick-circle.svg'
import graph from '../../../assets/images/graphaBar.png'
import graphRed from '../../../assets/images/graphRed.png'
import { useState } from "react";
import { label } from "yet-another-react-lightbox/*";

const RealtimeRiderPerformance = (props: any) => {
    document.title = "Orders | BuyPass";
    const riderCard = [
        {
            name: "Orders out for delivery Delayed Deliveries",
            number: 123,
            imges: [
                { imageName: waring },
            ]
        },
        {
            name: "Rider Assigned but not picked up",
            number: 456,
            imges: [
                { imageName: cellTab },
            ]
        },
        {
            name: "Unassigned orders",
            number: 789,
            imges: [
                { imageName: profile },
                { imageName: profile },
                { imageName: profile }
            ]
        },
        {
            name: "Active No. of Riders",
            number: 101,
            imges: [
                { imageName: noti },
            ]
        },
        {
            name: "Active No of Rides",
            number: 154,
            imges: [
                { imageName: graph },
            ]
        },
        {
            name: "Active Orders assigned to Riders",
            number: 102,
            imges: [
                { imageName: graphRed },
            ]
        },
        {
            name: "Total Completed Rides",
            number: 323,
            imges: [
                { imageName: waring },
            ]
        },
        {
            name: "Total Cancelled Rides",
            number: 103,
            imges: [
                { imageName: cellTab },
            ]
        },
        {
            name: "Total Payments collected by Riders",
            number: 104,
            imges: [
                { imageName: profile },
                { imageName: profile },
                { imageName: profile }
            ]
        },
        {
            name: "List of active orders assigned",
            number: 105,
            imges: [
                { imageName: noti },
            ]
        },
        {
            name: "List of unassigned orders assigned",
            number: 106,
            imges: [
                { imageName: graph },
            ]
        },
        {
            name: "List of delivered orders",
            number: 107,
            imges: [
                { imageName: graphRed },
            ]
        },
    ]
    const navigationHeader = [
        {
            label: "Today",
            active: true,
        },
        {
            label: "Yesterday",
            active: false,
        },
        {
            label: "Last 7 Days",
            active: false,
        },
        {
            label: "This Month",
            active: false,
        },
        {
            label: "Last Month",
            active: false,
        },
    ]
    const [navigations, setNavigations] = useState(navigationHeader[0]);
    const handleTabClick = (item: any) => {
      setNavigations(item);
    };
    return (
        <div className="page-content ordersMainPage">
            <ToastContainer />
            <Container fluid>
                <BreadCrumb
                    title="Realtime Rider Performance"
                    pageTitle="Orders"
                    pageTitleRoute="/manage-orders"
                />
                <div className="navigationBar">
                    <div className="navigation">
                        {navigationHeader.map((item, index) => (
                            <div  key={index} className={`navItem ${navigations.label === item.label ? 'active' :''}`} onClick={() => handleTabClick(item)}>
                                 <p>{item.label}</p>
                            </div>
                        ))}
                    </div>
                    <div className="fiterButton">
                        <i className='bx bxs-filter-alt'></i>
                        Filter
                    </div>
                </div>
                <div className="contentRow">
                    {riderCard.map((item, index) => (
                        <div className="riderCard">
                            <div className="headerRow">
                                <div className="name">
                                    <p>{item.name}</p>
                                </div>
                                <div className="profileROw">
                                    {item.imges.map((images: any, index) => (
                                        <div className="profile">
                                            <img src={images.imageName} alt="" />
                                        </div>
                                    ))}
                                </div>
                            </div>
                            <div className="footerRow">
                                <h3>{item.number}</h3>
                                <div className="viewBtn">View</div>
                            </div>
                        </div>
                    ))}
                </div>
            </Container>
        </div>
    );

};

export default RealtimeRiderPerformance;
